import { useEffect, useRef } from 'react';
import { UUID } from 'v2/core/entities/uuid';
import useGetIntegrationEditFormData from 'v2/core/repository/edge-server/integrations/editIntegrations/useGetIntegrationEditFormData';
import { QueryOptions } from 'v2/core/repository/edge-server/types';

export const useFetchSlackChannels = (
  integrationID: UUID,
  options?: QueryOptions,
  setIsPollingSlackChannelsInProgress?: (isLoading: boolean) => void,
) => {
  const intervalRef = useRef<number>();
  const { data, status, stopPolling, startPolling, refetch } =
    useGetIntegrationEditFormData(
      {
        integrationID,
      },
      options,
    );

  useEffect(() => {
    if (!data?.slack?.refreshID) {
      setIsPollingSlackChannelsInProgress?.(false);
      stopPolling();
      window.clearInterval(intervalRef.current);
    }
  }, [
    data?.slack?.refreshID,
    startPolling,
    stopPolling,
    setIsPollingSlackChannelsInProgress,
  ]);

  const refetchSlackChannels = (refreshID: string) => {
    refetch({
      integrationID,
      slack: {
        refreshID: refreshID,
      },
    });
  };

  const pollForSlackChannels = (refreshID?: string) => {
    if (!refreshID) {
      return;
    }
    setIsPollingSlackChannelsInProgress?.(true);
    refetchSlackChannels(refreshID);
    const intervalID = window.setInterval(() => {
      refetchSlackChannels(refreshID);
    }, 2000);

    intervalRef.current = intervalID;
  };

  return {
    data: data?.slack?.channelsInWorkspace ?? [],
    refreshID: data?.slack?.refreshID,
    status,
    startPolling,
    pollForSlackChannels,
  } as const;
};
